import { ErrorFallbackError } from "@/ErrorHandling/types";
import { extractValidationError, parseError } from "@/ErrorHandling/utils";
import { Alert } from "@mui/material";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";

export const ErrorAlert: React.FC<{ error: ErrorFallbackError | string | undefined | null }> = ({ error }) => {
  const { t } = useTranslation();

  if (!error) {
    return null;
  }

  let messageStr = "";
  // We don't need users to contact support if a validation error occurs
  let isValidationError = false;
  if (typeof error === "string") {
    messageStr = error;
  } else {
    const { msg } = parseError(error, t);
    messageStr = msg;
    isValidationError = extractValidationError(error) !== null;
  }
  return (
    <Alert severity="error">
      {messageStr}
      {!isValidationError && (
        <p className="mt-2">
          <Trans
            i18nKey="errors.if_error_persists"
            components={{
              a: (
                <a href={import.meta.env.VITE_SUPPORT_URL} target="_blank" className="text-blue-500">
                  text
                </a>
              ),
            }}
          />
        </p>
      )}
    </Alert>
  );
};
